<script>
import config from '@/assets/js/config.js'

export default {
  name: 'languages',
  data () {
    return {
      languages: config.languages
    }
  },
  methods: {
  },
  created () {
  }
}
</script>
